import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, delay, finalize } from 'rxjs';
import { environment } from 'src/environments/environment';

import { LoadingService } from '../services/loading.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private countRequest = 0;
  api = environment.api;
  constructor(private loadingService: LoadingService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // const isBackendRequest = request.url.includes(this.api) && !request.url.includes('.jpg') && !request.url.includes('.png');
    // let delaySeconds = 0;
    // if (request.url.includes('8080')) {
    // delaySeconds = 1000;
    // }
    // If this is the first of a group of overlapping requests, sets the spinner
    if (!this.countRequest) {
      this.loadingService.setLoadingState(true);
    }
    this.countRequest++;
    return next.handle(request).pipe(
      // delay(delaySeconds),
      finalize(() => {
        this.countRequest--;
        // If this was the last request, removes the spinner
        if (!this.countRequest) {
          this.loadingService.setLoadingState(false);
        }
      })
    );
  }
}
